import axios from 'axios';
import RouteUrls from '../common/RouteUrls'
import {getXSRFToken} from '../common/authTokenUtil';

export const credentialRecoverySubmit = async (accountNumber, zipCode, businessPhone) => {
    try {
        const response = await axios({
            method: 'POST',
            url: RouteUrls.CREDENTIAL_RECOVERY_SUBMIT,
            headers: {
                'correlation-id':
                    '12345',
                'client-id':
                    'PNET',
                'X-XSRF-TOKEN': getXSRFToken()
            },
            data: {
                accountNumber: accountNumber.replaceAll("-",""),
                zipCode: zipCode,
                businessPhone: businessPhone.replaceAll("-","")
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error while verifying User Id : ', error);
        throw error;
    }
}